import { render, staticRenderFns } from "./DetailTab.vue?vue&type=template&id=24eea582"
import script from "./DetailTab.vue?vue&type=script&lang=js"
export * from "./DetailTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports